import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Components
import { TextInput, Button } from "src/Components";
// Requests
import { getMarginConfig, setMarginConfig } from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { IMarginConfig } from "src/Interfaces/imePortfolio";

interface IProps {
  onClose: () => void;
}
const Setting: React.FC<IProps> = ({ onClose }) => {
  //local states
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] = React.useState<IMarginConfig>(
    {} as IMarginConfig,
  );

  React.useEffect(() => {
    getMarginConfig()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const clickHandler = () => {
    setLoading(true);
    setMarginConfig(formValues)
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
        onClose();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="grid gap-3 items-center ">
      <TextInput
        label="مرز ترمیم زودهنگام آتی"
        value={formValues.futureEarlyRepairThreshold?.toString()}
        name="futureEarlyRepairThreshold"
        onChange={changeHandler}
        kind="negativeDecimalNumbers"
        extraLabel
      />
      <TextInput
        label="سطح مطلوب در ترمیم زودهنگام آتی"
        value={formValues.futureEarlyRepairTarget?.toString()}
        name="futureEarlyRepairTarget"
        onChange={changeHandler}
        kind="negativeDecimalNumbers"
        extraLabel
      />
      <TextInput
        label="مرز ترمیم زودهنگام اختیار"
        value={formValues.optionEarlyRepairThreshold?.toString()}
        name="optionEarlyRepairThreshold"
        onChange={changeHandler}
        kind="negativeDecimalNumbers"
        extraLabel
      />
      <TextInput
        label="سطح مطلوب در ترمیم زودهنگام اختیار"
        value={formValues.optionEarlyRepairTarget?.toString()}
        name="optionEarlyRepairTarget"
        onChange={changeHandler}
        kind="negativeDecimalNumbers"
        extraLabel
      />
      <div className="mx-20 mt-5">
        <Button
          onClick={clickHandler}
          text="ثبت"
          variant="contained"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Setting;
